/* istanbul ignore file */

import getConfig from 'next/config';

// eslint-disable-next-line
const { publicRuntimeConfig }: { publicRuntimeConfig: AppConfig } = getConfig();

export interface AppConfig {
  NODE_ENV: string;
  NEXT_PUBLIC_VERSION: string;
  NEXT_PUBLIC_LOGOUT_URL: string;
  NEXT_PUBLIC_IDENTITY_API_URL: string;
  NEXT_PUBLIC_SAAS_TENANT_API_URL: string;
  NEXT_PUBLIC_CLOUD_TENANT_API_URL: string;
  NEXT_PUBLIC_COMMUNITY_URL: string;
  NEXT_PUBLIC_UNIVERSITY_URL: string;
  NEXT_PUBLIC_HELP_URL: string;
  NEXT_PUBLIC_ACCOUNTS_MANAGE_PROFILE_URL: string;
  NEXT_PUBLIC_ACCOUNTS_OVERVIEW_URL: string;
  NEXT_PUBLIC_ACCOUNTS_VIEW_ALL_URL: string;
  NEXT_PUBLIC_ACCOUNTS_LAUNCH_URL: string;
  NEXT_PUBLIC_BASE_PATH: string;
  NEXT_PUBLIC_TENANT_URL: string;
  NEXT_PUBLIC_TENANT_ID: string;
  NEXT_PUBLIC_LAUNCH_DARKLY_CLIENT_ID: string;
  NEXT_PUBLIC_REGION: string;
  NEXT_PUBLIC_TENANT_LOOKUP_SERVICE_URL: string;
  NEXT_PUBLIC_APPD_CELL: string;
  NEXT_PUBLIC_DASHUI_ENTITY_PAGE_DOCUMENT_TYPE: string;
}

export const config: Readonly<AppConfig> = {
  NODE_ENV: publicRuntimeConfig.NODE_ENV || '',
  NEXT_PUBLIC_VERSION: publicRuntimeConfig.NEXT_PUBLIC_VERSION || '',
  NEXT_PUBLIC_LOGOUT_URL: publicRuntimeConfig.NEXT_PUBLIC_LOGOUT_URL || '',
  NEXT_PUBLIC_IDENTITY_API_URL: publicRuntimeConfig.NEXT_PUBLIC_IDENTITY_API_URL || '',
  NEXT_PUBLIC_SAAS_TENANT_API_URL: publicRuntimeConfig.NEXT_PUBLIC_SAAS_TENANT_API_URL || '',
  NEXT_PUBLIC_CLOUD_TENANT_API_URL: publicRuntimeConfig.NEXT_PUBLIC_CLOUD_TENANT_API_URL || '',
  NEXT_PUBLIC_COMMUNITY_URL: publicRuntimeConfig.NEXT_PUBLIC_COMMUNITY_URL || '',
  NEXT_PUBLIC_UNIVERSITY_URL: publicRuntimeConfig.NEXT_PUBLIC_UNIVERSITY_URL || '',
  NEXT_PUBLIC_HELP_URL: publicRuntimeConfig.NEXT_PUBLIC_HELP_URL || '',
  NEXT_PUBLIC_ACCOUNTS_MANAGE_PROFILE_URL: publicRuntimeConfig.NEXT_PUBLIC_ACCOUNTS_MANAGE_PROFILE_URL || '',
  NEXT_PUBLIC_ACCOUNTS_OVERVIEW_URL: publicRuntimeConfig.NEXT_PUBLIC_ACCOUNTS_OVERVIEW_URL || '',
  NEXT_PUBLIC_ACCOUNTS_VIEW_ALL_URL: publicRuntimeConfig.NEXT_PUBLIC_ACCOUNTS_VIEW_ALL_URL || '',
  NEXT_PUBLIC_ACCOUNTS_LAUNCH_URL: publicRuntimeConfig.NEXT_PUBLIC_ACCOUNTS_LAUNCH_URL || '',
  NEXT_PUBLIC_TENANT_URL: publicRuntimeConfig.NEXT_PUBLIC_TENANT_URL || '',
  NEXT_PUBLIC_TENANT_ID: publicRuntimeConfig.NEXT_PUBLIC_TENANT_ID || '',
  NEXT_PUBLIC_LAUNCH_DARKLY_CLIENT_ID: publicRuntimeConfig.NEXT_PUBLIC_LAUNCH_DARKLY_CLIENT_ID || '',
  NEXT_PUBLIC_REGION: publicRuntimeConfig.NEXT_PUBLIC_REGION || '',
  NEXT_PUBLIC_TENANT_LOOKUP_SERVICE_URL: publicRuntimeConfig.NEXT_PUBLIC_TENANT_LOOKUP_SERVICE_URL || '',
  NEXT_PUBLIC_APPD_CELL: publicRuntimeConfig.NEXT_PUBLIC_APPD_CELL || '',
  NEXT_PUBLIC_DASHUI_ENTITY_PAGE_DOCUMENT_TYPE:
    publicRuntimeConfig.NEXT_PUBLIC_DASHUI_ENTITY_PAGE_DOCUMENT_TYPE || 'dashui:entityPage',
  NEXT_PUBLIC_BASE_PATH: publicRuntimeConfig.NEXT_PUBLIC_BASE_PATH || '',
};
